import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'

import { InterestRateKey } from '../../../../api/Interest-Rates/InterestRateDto'
import { links } from '../../../../utils/featureToggles'

const extractCurrency = (walletName: string) => {
  const regex = /([A-Z]{3})$/
  const match = walletName.match(regex)
  return match ? match[1] : null
}

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const clientDetailsInterestRatesColumns: GridColumn[] = [
  {
    title: 'Date',
    field: InterestRateKey.createdDate,
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.balanceDate, false)}
      </td>
    ),
    show: true,
    filter: 'text',
    filterable: true,
    sortable: true,
  },
  {
    title: 'Wallet',
    field: InterestRateKey.walletName,
    show: true,
    filter: 'text',
    cell: (props: GridCellProps): JSX.Element => {
      const wallet = props.dataItem?.wallet

      if (!wallet) {
        return <td />
      }

      const walletDetailsUrl = links.recordsWallets.detailsUrl as string
      const walletDetailsPath = generatePath(walletDetailsUrl, {
        id: wallet.id,
        slug: 'details',
      })

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            state={{ redirectTo: links.transactionWallet.url }}
            to={{
              pathname: walletDetailsPath,
            }}
          >
            {wallet.name}
          </Link>
        </td>
      )
    },
    filterable: true,
    sortable: false,
  },
  {
    title: 'Accrued Interest',
    field: InterestRateKey.amount,
    show: true,
    filter: 'text',
    filterable: true,
    sortable: false,
    cell: (props: GridCellProps): JSX.Element => {
      const currency = extractCurrency(props.dataItem.wallet.name)
      return (
        <td className='clients-table-columns__amount'>
          {currency && `${currency} `}
          {props.dataItem.amount}
        </td>
      )
    },
  },
]

export default clientDetailsInterestRatesColumns
